import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Header extends Component {
   handleMobileClick = (e) => {
    e.preventDefault();
    this.props.handleMobileClick(e);
  }
  render(){
    let mobileButtonClass = '';
    if(this.props.showMobileMenu){
      mobileButtonClass = 'active';
    }
    return(
      <header className="main">
        <h1 className="logo"><a href="/">Andy Yeo Sings</a></h1>

        <Link onClick={this.handleMobileClick} to='/' className={`mobile-menu ${mobileButtonClass}`}>
            <span className="span-1"></span>
            <span className="span-2"></span>
            <span className="span-3"></span>
        </Link>

      </header>
    );
  }
}
export default Header;


// WEBPACK FOOTER //
// ./src/modules/sections/Header.js